import React from 'react';
import { connect } from 'react-redux';
import { api } from "api";
import { renderField, renderSearchSelectPatient, renderSwitch } from 'Utils/renderField/renderField';
import { Field, reduxForm } from 'redux-form';

const getPatients = (search) => {
  return api.get("patients", {search}).catch((error) => {})
      .then((data) => {
          if (data){
              const patients = [];
              data.results.forEach(x=>{
                  patients.push({value: x.id, label: x.first_name + " " + x.last_name})
              })
              return patients
          }
          else{
              return []
          }
      })
      .catch(e => {
          return []
      })
}

const PatientAppointmentForm = props =>  {  
    const { 
      inSearchGoToWeek,
      cancel,      
      patient_appointments_list,
      registered,
      getPatientAppointments,
      clearPatientAppointments,
      handleSubmit
    } = props;

    const onSubmitForm = (values) => {
      getPatientAppointments(values);
    }

    return(
      <React.Fragment>
      <form        
        onSubmit={handleSubmit(onSubmitForm)}
      >
        <div 
            className="mb-md-4 d-flex justify-content-between flex-column flex-sm-row align-items-stretch align-items-sm-center"
        >
            <div className="m-2 d-flex"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '24px'
              }}
            >
                <div className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <label htmlFor="referred_by" className="">Paciente Registrado</label>
                </div>
                <div className=" d-flex justify-content-center  flex-column flex-sm-row align-items-stretch align-items-sm-center"
                >
                    <Field name="registered" component={renderSwitch} className="form-control"/>
                </div>
            </div>
        </div>        
          {registered ?
            <div className="m-2">          
              <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                  <label htmlFor="person" className="">Buscar y seleccionar paciente</label>
              </div>
              <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                  <Field
                      name="patient_search"
                      valueKey="value"
                      labelKey="label"
                      label="name"
                      component={renderSearchSelectPatient}
                      loadOptions={getPatients}
                      className="no-border"
                      onChange={(e) => {                     
                        //getPatientRegisteredAppointments(e.value);
                      }}
                  />
              </div>
        
            </div>
          :
            <div className="m-2">
                <div
                    className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <label htmlFor="patient_name" className="">Nombre del paciente</label>
                </div>
                <div
                    className=" d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <Field name="patient_name" component={renderField} type="text" className="form-control"/>
                </div>
            </div>            
          }

          <div className="row-fluid my-3">
              <div className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-around">
                  <a className="btn btn-small btn-secondary" to="/#/schedule/" onClick={cancel}>Cancelar</a>
                  <button
                    type="submit"
                    className="btn btn-small btn-primary"
                    //onClick={()=> this.searchInfo()}
                  >Buscar</button>
              </div>
          </div>
      </form>

      {patient_appointments_list && patient_appointments_list.length > 0 &&
      <div className='d-flex flex-column align-middle'>
        <span className='d-flex flex-row justify-content-center'>Consultas del (la) paciente:</span>
        {patient_appointments_list.map(appointment => (
          <button 
            className='d-flex flex-row justify-content-center new-link-hover'
            style={{
              textDecoration: 'none',
              color: '#000',
              fontWeight: 700
            }}
            onClick={() => inSearchGoToWeek(appointment.date.split("-").reverse().join("/"))}
          >{appointment.date.split("-").reverse().join("/")}</button>
        ))}

        <div className='d-flex flex-row justify-content-center mt-2'>
          <button onClick={() => clearPatientAppointments()} className='btn btn-xs btn-success' style={{ fontSize: '12px' }}>Nueva búsqueda</button>
        </div>
      </div>
      }      
      </React.Fragment>
    )  
}

const custom_validate = values => {
  const errors = {};
  if (values.patient_name === undefined || values.patient_name === null) {
      errors.patient_name = 'Campo requerido';
  } else if (values.patient_name.trim() === '') {
      errors.patient_name = 'Campo requerido';
  }
  if (values.patient_search === undefined || values.patient_search === null) {
      errors.patient_search = 'Campo requerido';
  }

  return errors;
};

let SearchTab = reduxForm({
  form: 'patient_appointments',
  validate: custom_validate
})(PatientAppointmentForm);

SearchTab = connect(state => {
  const registeredValue = state.form.patient_appointments && state.form.patient_appointments.values ? state.form.patient_appointments.values.registered : false;

  return {
    registered: registeredValue
  };
})(SearchTab);

export default SearchTab